var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoAnswerIcon = function SvgNoAnswerIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_icon_3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-140.000000, -713.000000)",
    fill: "#20BDA3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.084973,719.00002 L151.212163,715.872824 C151.595921,715.489097 151.595921,714.866906 151.212163,714.482844 L150.517158,713.787838 C150.1334,713.40408 149.51124,713.40408 149.127177,713.787838 L145.999992,716.915028 L142.872797,713.787838 C142.48907,713.40408 141.866879,713.40408 141.482816,713.787838 L140.787811,714.482844 C140.404053,714.866601 140.404053,715.488762 140.787811,715.872824 L143.915,719.00002 L140.787811,722.127204 C140.404053,722.510931 140.404053,723.133122 140.787811,723.517185 L141.482816,724.212191 C141.866574,724.595948 142.48907,724.595948 142.872797,724.212191 L145.999992,721.085001 L149.127177,724.212191 C149.510904,724.595948 150.1334,724.595948 150.517158,724.212191 L151.212163,723.517185 C151.595921,723.133427 151.595921,722.511267 151.212163,722.127204 L148.084973,719.00002 Z",
    id: "request_icon_3"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoAnswerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no_answer_icon.d04887192f66a20575e1fa83c8f7198d.svg";